import { isValuelessCondition } from "./conditionMeta";
import type { FilterStage } from "./state";

/**
 * Decides whether a column's pending stages are worth committing, and returns
 * the list to commit if so.
 *
 * A stage is "meaningful" once it carries a value, or once its condition needs
 * none (`is_empty` and friends). Until at least one stage clears that bar the
 * whole set stays in the popover's local pending state, so picking a condition
 * and pausing does not create a filter that matches everything.
 *
 * Once one stage qualifies, every stage commits — including earlier ones the
 * user gave a condition but no value yet — so the filter reads the way the
 * popover looks.
 */
export function pendingStagesToCommit(
  stages: FilterStage[],
): FilterStage[] | null {
  const hasMeaningful = stages.some(
    (stage) => stage.value !== "" || isValuelessCondition(stage.condition),
  );
  return hasMeaningful ? stages : null;
}
